
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1mjmy_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1mjmy_20",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1mjmy_20",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1mjmy_63",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1mjmy_63",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1mjmy_66",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1mjmy_66",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1mjmy_69",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1mjmy_69",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1mjmy_69",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1mjmy_69",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1mjmy_72",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1mjmy_72",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1mjmy_72",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1mjmy_72",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_1mjmy_76",
  "body": "awsui_body_xjuzf_1mjmy_87",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1mjmy_123",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_1mjmy_126",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1mjmy_131",
  "dismiss": "awsui_dismiss_xjuzf_1mjmy_136",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1mjmy_144",
  "header-row": "awsui_header-row_xjuzf_1mjmy_148",
  "header": "awsui_header_xjuzf_1mjmy_148",
  "content": "awsui_content_xjuzf_1mjmy_177",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1mjmy_186",
  "container": "awsui_container_xjuzf_1mjmy_194",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1mjmy_205",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1mjmy_205",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1mjmy_205",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1mjmy_210",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1mjmy_210",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1mjmy_210",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1mjmy_215",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1mjmy_215",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1mjmy_220",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1mjmy_220",
  "container-body": "awsui_container-body_xjuzf_1mjmy_226",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1mjmy_266",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1mjmy_271",
  "fixed-width": "awsui_fixed-width_xjuzf_1mjmy_274",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1mjmy_278",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1mjmy_285",
  "container-arrow": "awsui_container-arrow_xjuzf_1mjmy_205",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1mjmy_335",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1mjmy_1",
  "refresh": "awsui_refresh_xjuzf_1mjmy_389",
  "awsui-popover-settle-down": "awsui_awsui-popover-settle-down_xjuzf_1mjmy_1",
  "awsui-popover-settle-up": "awsui_awsui-popover-settle-up_xjuzf_1mjmy_1",
  "awsui-popover-settle-end": "awsui_awsui-popover-settle-end_xjuzf_1mjmy_1",
  "awsui-popover-settle-start": "awsui_awsui-popover-settle-start_xjuzf_1mjmy_1",
  "root": "awsui_root_xjuzf_1mjmy_514",
  "no-wrap": "awsui_no-wrap_xjuzf_1mjmy_546",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_1mjmy_549",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_1mjmy_549",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1mjmy_549",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_1mjmy_571",
  "trigger": "awsui_trigger_xjuzf_1mjmy_549",
  "in-inline-token": "awsui_in-inline-token_xjuzf_1mjmy_613",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_1mjmy_661",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_1mjmy_665",
  "hover-area": "awsui_hover-area_xjuzf_1mjmy_669"
};
  